module.exports = __webpack_public_path__ + "img/link-bluesky.6eb1086.png";